(function () {

    const anchor = document.querySelector('.landing-body[data-modal]');
    const trigger = document.querySelector('.js-modal-trigger');

    if (!anchor || !trigger) return;

    const form = anchor.querySelector('.landing-form');
    if (!form) return;

    // -----------------------------------------------------------------------
    // Build <dialog>
    // -----------------------------------------------------------------------

    const dialog = document.createElement('dialog');
    dialog.className = 'landing-overlay-dialog';
    dialog.setAttribute('aria-label', 'Get in touch');

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'modal-close';
    closeBtn.id = 'landing-close';
    closeBtn.setAttribute('aria-label', 'Close dialog');
    closeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

    dialog.appendChild(closeBtn);
    dialog.appendChild(form); // move form from anchor into dialog
    document.body.appendChild(dialog);

    // -----------------------------------------------------------------------
    // Positioning — match dialog rect to anchor rect
    // -----------------------------------------------------------------------

    const CLOSE_DURATION = 250;

    function positionDialog() {
        const rect = anchor.getBoundingClientRect();
        dialog.style.width  = rect.width + 'px';
        dialog.style.height = rect.height + 'px';
        dialog.style.top    = rect.top + 'px';
        dialog.style.left   = rect.left + 'px';
    }

    // -----------------------------------------------------------------------
    // Focus management helpers
    // -----------------------------------------------------------------------

    function getFocusable() {
        return Array.from(
            dialog.querySelectorAll(
                'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
            )
        ).filter(el => !el.closest('[hidden]') && el.offsetParent !== null);
    }

    function focusFirst() {
        const first = getFocusable()[0];
        (first || dialog).focus();
    }

    // -----------------------------------------------------------------------
    // Open / close
    // -----------------------------------------------------------------------

    function openModal() {
        positionDialog();
        document.body.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded', 'true');
        dialog.showModal();
        focusFirst();
    }

    function closeModal() {
        dialog.classList.add('is-closing');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(function () {
            dialog.classList.remove('is-closing');
            dialog.close();
            trigger.focus();
        }, CLOSE_DURATION);
    }

    // -----------------------------------------------------------------------
    // Event listeners
    // -----------------------------------------------------------------------

    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-haspopup', 'dialog');

    trigger.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);

    // ESC — prevent native close so we keep aria state consistent
    dialog.addEventListener('cancel', function (e) {
        e.preventDefault();
        closeModal();
    });

    // Backdrop click — click lands on <dialog> itself, not a child
    dialog.addEventListener('click', function (e) {
        if (e.target === dialog) closeModal();
    });

    // Focus trap
    dialog.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !dialog.open) return;

        const focusable = getFocusable();
        if (!focusable.length) return;

        const first = focusable[0];
        const last  = focusable[focusable.length - 1];

        if (e.shiftKey) {
            if (document.activeElement === first) {
                e.preventDefault();
                last.focus();
            }
        } else {
            if (document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    });

    // -----------------------------------------------------------------------
    // Reposition on resize (debounced)
    // -----------------------------------------------------------------------

    let resizeTimer;
    function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            if (dialog.open) positionDialog();
        }, 50);
    }

    window.addEventListener('resize', onResize);

    if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () {
            if (dialog.open) positionDialog();
        }).observe(anchor);
    }

})();
